import dynamic from 'next/dynamic';
const SocialEmbeds = dynamic(() => import('./SocialEmbeds'));
export default SocialEmbeds;
